export const platform: 'web' | 'android' | 'ios' = 'web';
